import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Input, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { User } from '../../clients/aasServerClient.generated';
import { canSeeUsersPage } from '../../stores/auth/selectors';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import { fetchTableUsers,FetchTableUsersNoSearch } from '../../stores/users/actionCreators';
import { getTableUsers } from '../../stores/users/selectors';
import DashboardContainer from '../dashboard/DashboardContainer';
import ViewContainer from '../layout/ViewContainer';
import Table from '../table/Table';
import TableBody from '../table/TableBody';
import TableColumn from '../table/TableColumn';
import TableHead from '../table/TableHead';
import TableToolbar from '../table/TableToolbar';
import UserTableHead from './UsersTableHead';
import UserTableRow from './UsersTableRow';
import UsersToolbar from './UsersToolbar';
import { TableFilters } from '../../stores/tables/state';




export interface Props extends RouteComponentProps, LocalizeContextProps {
    users: User[];
    canSeeUsersPage: boolean;
    loading: boolean;    
    fetchUsers: () => void;
    fetchUsersNoSearch :() => void;    
    lState : RootState;
}

export class UsersPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        if (props.canSeeUsersPage) {        
            this.props.lState.tables['users'].search ='';               
            this.props.fetchUsersNoSearch();                        
        }
    }

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="table-view">
                <div>
                    <h1>{t('users.header.users')}</h1>
                    {this.props.loading ? <Spinner /> : null}
                </div>
                <Table
                    toolbar={<UsersToolbar />}
                    refresh={this.props.fetchUsers }
                    tableKey="users"
                >
                    <UserTableHead refresh={this.props.fetchUsers} ids={this.props.users.map((u) => u.id)} />
                    <TableBody>
                        {this.props.users.map((user, i) => (
                            <UserTableRow key={i} user={user} />
                        ))}
                    </TableBody>
                </Table>
            </ViewContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    canSeeUsersPage: canSeeUsersPage(state),
    loading: isLoading(state), 
    users: getTableUsers(state),
    lState : state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
     
    fetchUsersNoSearch : () => dispatch(FetchTableUsersNoSearch()),
    fetchUsers: () => dispatch(fetchTableUsers()),
    
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(UsersPage)));
